import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotebookPen = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "var(--icon-color, currentColor)",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-notebook-pen-icon lucide-notebook-pen",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4" }),
		/* @__PURE__ */ _jsx("path", { d: "M2 6h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M2 10h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M2 14h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M2 18h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" })
	]
});
export default SvgNotebookPen;
